
        Component.define('share', (el, params) => {
            /**
 * Each component receives the variables explained below
 *
 * @param {HTMLElement} el - Component's main DOM element
 * @param {Object} params - Params to be used
 */

const $el = $(el);
const $copy = $el.find('.copiar');
const $twitter = $el.find('.twitter');
const $facebook = $el.find('.facebook');

const clipboard = new ClipboardJS('.copiar', {
    text: function(el) {
        return window.location.href;
    }
});

let timeout;

clipboard.on('success', function(e) {
    const $i = $copy.find('i');
    $i.addClass('show-success');

    clearTimeout(timeout);
    timeout = setTimeout(() => {
        $i.removeClass('show-success');
    }, 2000);
});

$twitter.on('click', function() {
    Share.twitter(window.location.href, '');

    return false;
});

$facebook.on('click', function() {
    Share.facebook(window.location.href);

    return false;
});

        });